import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import React, { FC } from "react";
import PricesList from "./PricesList";
import Photos from "./Photos";
import Overview from "./Overview";

interface Props {
  selectedTour: any;
  isSheetOpen: any;
  setIsSheetOpen: any;
}

const TourDetails: FC<Props> = ({
  selectedTour,
  isSheetOpen,
  setIsSheetOpen,
}) => {
  const [paths, setPaths] = React.useState<{ key: string; imageUrl: string }[]>(
    Array(4).fill({ key: "", imageUrl: "" }),
  );

  const getPhotos = (data: any) => {
    setPaths(data);
  };

  return (
    <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
      <SheetContent
        side="bottom"
        className="max-h-[90vh] sm:h-auto p-4 sm:p-10 overflow-y-auto"
      >
        <SheetHeader className="mb-4">
          <SheetTitle className="text-xl sm:text-3xl">
            {selectedTour.name}
          </SheetTitle>
        </SheetHeader>
        <Tabs defaultValue="overview" className="w-full">
          <TabsList className="grid w-full sm:w-[60vh] grid-cols-2 mb-4">
            <TabsTrigger value="overview">Overview</TabsTrigger>
            <TabsTrigger value="prices">Prices</TabsTrigger>
          </TabsList>
          <TabsContent
            value="overview"
            className="w-full flex flex-col xl:flex-row items-start gap-4 sm:gap-8"
          >
            <div className="w-full sm:grid-cols-1">
              <h3 className="text-base sm:text-lg font-semibold mb-2">
                Photos
              </h3>
              <Photos
                selectedTour={selectedTour}
                photos={getPhotos}
                paths={paths}
                setPaths={setPaths}
              />
            </div>
            <div className="w-full flex items-center justify-center sm:grid-cols-1">
              <div className="w-full max-w-4xl">
                <h3 className="text-base sm:text-lg font-semibold mb-2">
                  Details
                </h3>
                <Overview
                  details={selectedTour}
                  photos={paths}
                  setPhotos={setPaths}
                />
              </div>
            </div>
          </TabsContent>
          <TabsContent value="prices">
            <div className="mt-4 space-y-2">
              <h3 className="text-base sm:text-lg font-semibold">Prices</h3>
              <PricesList selectedTour={selectedTour} />
            </div>
          </TabsContent>
        </Tabs>
      </SheetContent>
    </Sheet>
  );
};

export default TourDetails;
